import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25d2222d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "photoView",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "bannerText",
  class: "alert alert-primary text-center"
}, "The selected photo and any edited fields will be applied to the Transfer to Form column on save.", -1))
const _hoisted_5 = { class: "container-fluid" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "col",
  id: "mlsContainerLeft"
}
const _hoisted_8 = { id: "photosSection" }
const _hoisted_9 = { class: "photo-header" }
const _hoisted_10 = { class: "photo" }
const _hoisted_11 = {
  key: 0,
  class: "is-selected"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = { id: "commentsSection" }
const _hoisted_16 = {
  class: "col",
  id: "mlsContainerRight"
}
const _hoisted_17 = { class: "preview-photo mb-3" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "no-property-image-container"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "no-property-image fas fa-home" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "container-fluid" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-8" }
const _hoisted_25 = { class: "container p-0" }
const _hoisted_26 = { class: "row flex-nowrap" }
const _hoisted_27 = { class: "col-sm-auto initial-badge-container pt-1" }
const _hoisted_28 = { class: "col ms-0 ellipsis" }
const _hoisted_29 = { class: "col-4 text-end" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notes = _resolveComponent("Notes")!
  const _component_Dropdowns = _resolveComponent("Dropdowns")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalBody, { id: "modalBody" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.photoGallery, (sourceInitial) => {
                      return (_openBlock(), _createElementBlock("div", { key: sourceInitial }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createTextVNode(_toDisplayString(sourceInitial.label) + " ", 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["photo-header-bar", [`source-${sourceInitial.sourceInitial}`]])
                          }, null, 2)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceInitial.photo, (photo) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "photo-container",
                            key: photo.full
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              (_ctx.isActivePhoto(photo.guid))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                                : _createCommentVNode("", true),
                              _createElementVNode("img", {
                                class: _normalizeClass([this.isActivePhoto(photo.guid) ? 'is-selected-img' : '']),
                                src: photo.thumbnail,
                                onClick: ($event: any) => (_ctx.preview(photo.full, photo.guid))
                              }, null, 10, _hoisted_14)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Notes, {
                      showStats: true,
                      notes: this.compPhotoNotes,
                      onCallback: _ctx.NotesCallback
                    }, null, 8, ["notes", "onCallback"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (this.previewPhoto !== '')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: this.previewPhoto
                        }, null, 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (this.previewPhoto === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Dropdowns, { onCallback: _ctx.DropdownsCallback }, null, 8, ["onCallback"])
                ])
              ])
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  showLBackDrop: true,
                  showLoadingText: true,
                  loadingText: "Loading..."
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.photoGallery, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "photo-count-container float-start me-3"
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["me-0", [`initial-badge-${index}`]])
                            }, null, 2)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("span", null, _toDisplayString(item.label) + " - " + _toDisplayString(item.count), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary me-1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                  }, "Save"),
                  _hoisted_30
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}